import { render, staticRenderFns } from "./biantengtoushi.vue?vue&type=template&id=bac65ef4&scoped=true&"
import script from "./biantengtoushi.vue?vue&type=script&lang=js&"
export * from "./biantengtoushi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac65ef4",
  null
  
)

export default component.exports